import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './lib/i18n';
import './styles/index.css';
import { AuthProvider } from './features/auth/auth-context';
import { createQueryClient } from './lib/query-client';
import { installStaleChunkReload } from './lib/stale-chunk-reload';
import { initTheme } from './lib/theme';
import { routeTree } from './routeTree.gen';

initTheme();
installStaleChunkReload();

const queryClient = createQueryClient();
const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Không tìm thấy #root');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider bọc ngoài Router: route layout `_app` đọc trạng thái
          phiên để quyết định cho vào hay đá về /login. */}
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
